export const blockIconsPlacesChildFriendly = (
	<span className='material-symbols-outlined'>child_friendly</span>
);
